import { useQuery } from '@tanstack/react-query'

export interface SeedbotWallet {
  address: string
  balanceSol: string
  isLow: boolean
}

export interface SeedbotHealthData {
  status: string
  uptime: number
  autoLaunch?: {
    dextoro: boolean
    pumpfun: boolean
  }
  scheduler: {
    running: boolean
    launchesPerHour: number
  }
  stats: {
    totalAttempts: number
    totalSuccesses: number
    totalFailures: number
    successRate: string
  }
  wallets: SeedbotWallet[]
  contentLibrary: {
    totalConcepts: number
  }
  bundleConfig?: {
    dextoroEnabled?: boolean
    pumpfunEnabled?: boolean
  }
  trendingPipeline?: {
    cachedTopicCount: number
    actors?: {
      id: string
      name: string
      platform: string
      apifyUrl: string
    }[]
    lastAIConcept?: {
      name: string
      ticker: string
      trendTopic?: string
    }
  }
  config?: {
    falModel: string
    styleVariationCount: number
    tickerStyles: { style: string; count: number; percentage: number }[]
    vanitySuffix: string
    minWalletBalance: number
    ipfsGateway: string
  }
  fetchedAt: number
}

export const SEEDBOT_BASE_URL = 'https://dextoro-seedbot-production.up.railway.app'
const HEALTH_URL = `${SEEDBOT_BASE_URL}/health`

export function useSeedbotHealth() {
  return useQuery({
    queryKey: ['seedbot-health'],
    queryFn: async (): Promise<SeedbotHealthData> => {
      const res = await fetch(HEALTH_URL)
      if (!res.ok) {
        throw new Error(`Health endpoint returned ${res.status}`)
      }
      const data = await res.json()
      return {
        ...data,
        fetchedAt: Date.now(),
      }
    },
    staleTime: 15_000,
    refetchInterval: 30_000,
  })
}
